import { ReactNode } from 'react';

import { cn } from '@/utils/cn-tw-merge';

export interface SuggestionSectionProps {
  icon: ReactNode;
  title: string;
  featuredCard: ReactNode;
  previewCard?: ReactNode;
  additionalCards?: ReactNode;
  cta?: ReactNode;
}

export function SuggestionSection({
  icon,
  title,
  featuredCard,
  previewCard,
  additionalCards,
  cta,
}: SuggestionSectionProps) {
  return (
    <div className="flex w-full flex-col gap-4 rounded-xxl bg-green-300 p-3 sm:p-6">
      <div className="flex flex-col gap-2">
        <div className="flex size-8 items-center justify-center rounded-full">{icon}</div>
        <h3 className="text-lg font-bold leading-6 text-green-900">{title}</h3>
      </div>
      {featuredCard}
      {additionalCards}
      {previewCard
        ? (
            <div className="relative max-h-[168px] overflow-hidden rounded-2xl">
              <div inert className="pointer-events-none">
                {previewCard}
              </div>
              <div
                aria-hidden
                className={cn(
                  'pointer-events-none absolute inset-x-0 bottom-0 top-14 bg-white/[0.16] backdrop-blur-[4px]',
                  '[-webkit-mask-image:linear-gradient(to_bottom,transparent_0,black_32px)]',
                  '[mask-image:linear-gradient(to_bottom,transparent_0,black_32px)]',
                )}
              />
              <div className="absolute inset-x-0 bottom-0 flex justify-center p-3">
                <div className="w-full drop-shadow-[0_4px_2px_rgba(0,0,0,0.25)] xl:w-80">{cta}</div>
              </div>
            </div>
          )
        : null}
      {!previewCard && cta
        ? (
            <div className="w-full xl:w-80 xl:self-center">{cta}</div>
          )
        : null}
    </div>
  );
}
